import { render } from "./FolderAssignmentsModal.vue?vue&type=template&id=ca935e12&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./FolderAssignmentsModal.vue?vue&type=script&lang=js"
export * from "./FolderAssignmentsModal.vue?vue&type=script&lang=js"

import "./FolderAssignmentsModal.vue?vue&type=style&index=0&id=ca935e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca935e12"]])

export default __exports__